import React from 'react';
import { has } from 'lodash';
import { SafeComponent } from '@fiverr-private/orca';
import { logger, stats } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';

export const SafeWrapper = <P>(
    Component: React.ComponentType<P>,
    componentName: string,
    staticProps: Record<string, any> = {}
) => {
    const SafeWrappedComponent = SafeComponent(Component, (e: Error) => {
        const isLegacyReporter = has(window, 'Fiverr._logErrorToServer');

        const details = {
            description: 'Error in component',
            component: componentName,
            context: getContext(),
            package: 'seller_pages_toolbox',
        };

        if (!isLegacyReporter) {
            logger.error(e, { details });
            stats.count('seller_pages_toolbox', 'error');
        } else {
            logger.error(e);
        }

        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line
            console.error(e);
        }
    });

    Object.assign(SafeWrappedComponent, staticProps);

    return SafeWrappedComponent as React.ComponentType<P>;
};
